import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';

import { colors } from '../../styles/theme';

const Li = styled('li')`
  border-top: 1px solid ${colors.grey.secondary};
  &:first-of-type {
    border-top: 0;
  }
`;

const Ul = styled('ul')`
  padding: 0;
`;

const DropdownMenuGroup = ({ children }) => (
  <Li>
    <Ul>{children}</Ul>
  </Li>
);

DropdownMenuGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default DropdownMenuGroup;
